module.exports = __webpack_public_path__ + "img/message-order@2x.eeada53b.png";